import { GQLPlugin } from '../GQLTypes';

// eslint-disable-next-line
function reference (obj: any, str: string): string {
  return str.split('.').reduce((o, x) => {
    return o[x];
  }, obj);
}

export const AuthPlugin: GQLPlugin = (
  { beforeRequest },
  { store, tokenPath = 'auth.token', tenantIdPath = 'auth.tenantId' }
) => {
  beforeRequest.push(({ headers }) => {
    headers.set('Authorization', 'Bearer ' + reference(store.state, tokenPath));
    headers.set('X-Tenant-Id', reference(store.state, tenantIdPath));
  });
};
